import { render, staticRenderFns } from "./PlacementTypes.vue?vue&type=template&id=025056a4&scoped=true&"
import script from "./PlacementTypes.vue?vue&type=script&lang=js&"
export * from "./PlacementTypes.vue?vue&type=script&lang=js&"
import style0 from "./PlacementTypes.vue?vue&type=style&index=0&id=025056a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025056a4",
  null
  
)

export default component.exports